import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M4 20a7.5 7.5 0 0 1 7.5-7.5c.877 0 2.5 0 4 1.5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-1.898 5.408a6 6 0 1 0-5.67-.25A8.25 8.25 0 0 0 3.25 20a.75.75 0 0 0 1.5 0 6.75 6.75 0 0 1 6.75-6.75c.843 0 2.195.006 3.47 1.28a.75.75 0 1 0 1.06-1.06 5.9 5.9 0 0 0-1.428-1.062M17.06 14.52a.5.5 0 0 1 .587.26.4.4 0 0 0 .353.232.4.4 0 0 0 .353-.232.5.5 0 0 1 .588-.26 3.47 3.47 0 0 1 1.449.843.5.5 0 0 1 .104.573.5.5 0 0 0-.044.2c0 .26.198.436.4.436h.005a.5.5 0 0 1 .486.355 3.74 3.74 0 0 1 .089 1.806.5.5 0 0 1-.542.401l-.038-.002c-.202 0-.4.177-.4.437 0 .113.039.213.1.288a.5.5 0 0 1-.021.655 3.5 3.5 0 0 1-1.524.966.5.5 0 0 1-.625-.331.405.405 0 0 0-.38-.298.405.405 0 0 0-.38.298.5.5 0 0 1-.625.33 3.5 3.5 0 0 1-1.524-.965.5.5 0 0 1-.021-.655.46.46 0 0 0 .1-.288c0-.26-.198-.436-.4-.436q-.02 0-.038.002a.5.5 0 0 1-.542-.402 3.75 3.75 0 0 1 .089-1.806.5.5 0 0 1 .486-.355h.005c.202 0 .4-.177.4-.436a.5.5 0 0 0-.044-.2.5.5 0 0 1 .104-.573c.403-.39.898-.685 1.45-.843m-.53 1.369q.02.12.02.247c0 .64-.415 1.202-1.006 1.379a2.8 2.8 0 0 0-.039.664 1.43 1.43 0 0 1 1.045 1.39q0 .267-.09.505.214.174.46.299a1.38 1.38 0 0 1 1.08-.524c.441 0 .827.207 1.08.524q.246-.124.46-.3a1.5 1.5 0 0 1-.09-.504c0-.654.434-1.227 1.045-1.39a2.8 2.8 0 0 0-.04-.664 1.435 1.435 0 0 1-.984-1.626 2.5 2.5 0 0 0-.488-.291 1.376 1.376 0 0 1-1.966 0 2.5 2.5 0 0 0-.488.29",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.5 18a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }